import { useMemo } from "react";

/**
 * DateOfBirthPicker — friendly 3-dropdown (Day/Month/Year) selector.
 * Emits an ISO "YYYY-MM-DD" string via onChange.
 * Works consistently across Android, iOS, and desktop (no browser-specific year scrolling).
 */
export default function DateOfBirthPicker({ value, onChange, testid = "dob-picker" }) {
  const parts = parseIso(value);
  const [dd, setDd] = [parts.d, (v) => onChange(assemble({ ...parts, d: v }))];
  const [mm, setMm] = [parts.m, (v) => onChange(assemble({ ...parts, m: v }))];
  const [yy, setYy] = [parts.y, (v) => onChange(assemble({ ...parts, y: v }))];

  const currentYear = new Date().getFullYear();
  const years = useMemo(() => {
    const arr = [];
    for (let y = currentYear - 13; y >= currentYear - 100; y--) arr.push(y);
    return arr;
  }, [currentYear]);
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  const daysInMonth = new Date(yy || currentYear, mm || 1, 0).getDate();
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  return (
    <div data-testid={testid} className="grid grid-cols-3 gap-2">
      <select data-testid={`${testid}-day`} value={dd || ""} onChange={(e) => setDd(parseInt(e.target.value) || null)}
        className="rounded-xl border border-gray-200 bg-white px-3 py-3 text-sm">
        <option value="">Day</option>
        {days.map((d) => <option key={d} value={d}>{d}</option>)}
      </select>
      <select data-testid={`${testid}-month`} value={mm || ""} onChange={(e) => setMm(parseInt(e.target.value) || null)}
        className="rounded-xl border border-gray-200 bg-white px-3 py-3 text-sm">
        <option value="">Month</option>
        {months.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
      </select>
      <select data-testid={`${testid}-year`} value={yy || ""} onChange={(e) => setYy(parseInt(e.target.value) || null)}
        className="rounded-xl border border-gray-200 bg-white px-3 py-3 text-sm">
        <option value="">Year</option>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}

function parseIso(iso) {
  if (!iso || typeof iso !== "string") return { d: null, m: null, y: null };
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return { d: null, m: null, y: null };
  return { y: parseInt(m[1]), m: parseInt(m[2]), d: parseInt(m[3]) };
}

function assemble({ y, m, d }) {
  if (!y || !m || !d) return "";
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}
